import React from "react"
import Button from "@material-ui/core/Button"
import { withStyles } from "@material-ui/core/styles"
// import i18n from "../../translation/i18next"
// import { withTranslation } from "react-i18next"

import "./button.scss"

const styles = theme => ({
  button: {
    color: "#F4F4F4",
    "&$buttonDisabled": {
      color: "#F4F4F4",
      borderColor: "#F4F4F4",
    },
  },
  buttonDisabled: {},
})

class ProdhostButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: false,
      variant: "contained",
      className: "",
    }
  }

  checkPrimaryOrSecondary() {
    if (this.props.type === "primary") {
      this.setState({
        variant: "contained",
      })
    } else {
      this.setState({
        variant: "outlined",
      })
    }
  }

  checkDisabled() {
    if (this.props.disabled) {
      this.setState({
        disabled: true,
      })
    }
  }

  createClassName() {
    this.setState({
      className: `${this.props.type}${this.props.disabled ? "_disabled" : ""}${
        this.props.model ? "_" + this.props.model : ""
      }`,
    })
  }

  componentWillMount() {
    this.checkPrimaryOrSecondary()
    this.checkDisabled()
    this.createClassName()
  }

  render() {
    const { classes, text, onClick } = this.props
    const { variant, className } = this.state

    return (
      <Button
        variant={variant}
        className={className}
        disabled={this.state.disabled}
        classes={
          className === "secondary_disabled"
            ? { root: classes.button, disabled: classes.buttonDisabled }
            : {}
        }
        onClick={onClick}
      >
        {text ? /* i18n.t( */text/* ) */ : /* i18n.t( */"button text"/* ) */}
      </Button>
    )
  }
}

export default /* withTranslation()( */withStyles(styles)(ProdhostButton)/* ) */
